import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

import { AttributeType } from '@containers/ProductListing/model';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

export const usePriceWithVoucher = ({
  price,
  attributes,
}: {
  price: CatalogVariantFragmentFragment['price'];
  attributes: AttributeType | undefined;
}) => {
  const voucherDiscount = useResolvedVoucherDiscount({ attributes });
  if (!voucherDiscount) {
    return price;
  }

  if (isConditionalDiscount(voucherDiscount)) {
    if (voucherDiscount.discountType === 'Absolute') {
      return price;
    }

    const fulfilledConditions = voucherDiscount.discountConditions.filter(
      ({ productMeetsCondition }) => productMeetsCondition
    );

    const minDiscountedPrice = Math.min(
      ...fulfilledConditions.map(({ discountedPrice }) => discountedPrice)
    );

    return fulfilledConditions.length > 0
      ? { ...price, value: minDiscountedPrice }
      : price;
  }

  return { ...price, value: voucherDiscount.discountedPrice };
};
